export default __webpack_public_path__ + "static/bg-startups-083ecbf46f39826c0e1d94c6c031c01a.jpg";